import { render, staticRenderFns } from "./screenViewMachine.vue?vue&type=template&id=63fb62c8&"
import script from "./screenViewMachine.vue?vue&type=script&lang=js&"
export * from "./screenViewMachine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports